//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
	background-color: var(--light-1);
	border-radius: 8px;
	padding: 12px 16px;
	border: 2px solid transparent;
	width: 140px;
	transition: 0.35s;
	user-select: none;
	cursor: pointer;
	& span {
		font-size: 13px;
		font-weight: 600;
		color: var(--purple-6);
	}
	&:not(.selected) {
		box-shadow: 2px 3px 10px 4px var(--light-blue-2);
	}
	&.selected {
		border-color: var(--purple-2);
	}
	&.error {
		border-color: var(--red-3);
	}
	&.disabled {
		pointer-events: none;
		opacity: 0.5;
	}
`;
